import(/* webpackMode: "eager", webpackExports: ["Anchor"] */ "/vercel/path0/node_modules/@radix-ui/react-popover/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default","iconNames"] */ "/vercel/path0/node_modules/lucide-react/dist/esm/DynamicIcon.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/media/Image/variants/ImageWithSkeleton/image-with-skeleton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/project/ContactUsSection/contact-us-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/project/Hero/hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/shared/Visibility/visibility.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ui/Accordion/parts/accordion-content.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ui/Accordion/parts/accordion-item.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ui/Accordion/parts/accordion-root.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ui/Accordion/parts/accordion-trigger.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ui/Accordion/provider/AccordionItem/context.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ui/Accordion/provider/AccordionItem/provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ui/Accordion/provider/AccordionItem/use-accordion-item.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ui/Popover/parts/popover-content.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ui/Popover/parts/popover-root.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ui/Popover/parts/popover-trigger.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/lib/utils/useMergeRefs.ts");
